<div style="padding: 25px">
  <div class="flex flex-col xl:flex-row gap-2 justify-between">
    <span class="flex justify-start items-center text-black font-black uppercase"> Lista de Médicos </span>
    <div class="flex justify-start lg:justify-end flex-wrap gap-2">
      <div>
        <select
          class="w-60 form-select form-select-lg mr-5 text-white font-medium bg-blumine"
          aria-label=".form-select-lg"
          [formControl]="ordenarControl"
        >
          <option disabled>Ordenar</option>
          <option *ngFor="let order of opcoesOrdenacao" [value]="order.value">{{ order.label }}</option>
        </select>
      </div>
      <form class="contents" role="search" aria-label="Pesquisar médicos" (ngSubmit)="filtrarMedico()">
        <div>
          <input
            [formControl]="acaoInput"
            type="search"
            class="form-input w-60"
            placeholder="Pesquise por Nome ou CPF"
            aria-label="Pesquise por Nome ou CPF"
          />
        </div>
        <div class="flex justify-between">
          <button type="submit" title="Filtrar Médicos" class="px-5 min-w-max btn btn--secondary h-35 ml-5">
            <img class="w-6 h-6" src="./assets/icons/search_white.svg" alt="search" />
          </button>
          <button
            type="button"
            title="Limpar Filtros"
            (click)="limparFiltros()"
            class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine"
          >
            <img class="w-6 h-6" src="./assets/icons/backspace_white.svg" alt="search" />
          </button>
          <button
            type="button"
            *isAllowed="[ERoleAdminString.Admin, 'doctor.export']"
            title="Download Excel Médicos"
            class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine"
            (click)="downloadExcel()"
          >
            <img class="w-6 h-6" src="./assets/icons/download.svg" alt="Download Excel" />
          </button>
        </div>
      </form>
    </div>
  </div>

  <div class="inline-block w-full mt-8">
    <app-list-doctors
      [doctors]="doctors"
      [dadosPaginacao]="dadosPaginacao"
      (mudouPagina)="mudouPagina($event)"
      (mudouTamanhoPagina)="mudouTamanhoPagina($event)"
      (recarregarListagem)="carregarMedicos()"
    ></app-list-doctors>
  </div>

  <app-register-doctor (recarregarListagem)="carregarMedicos()" [companyId]="companyId"></app-register-doctor>

  <hr class="my-8" />
</div>
